<template>
  <div>
    <m-verify-transaction-1/>
  </div>
</template>

<script>

export default {
  name: "VerifyTransaction",
}
</script>